export default class ImageReveal {
    constructor(elem, APP) {
        this.elem = elem
        this.italics = [...this.elem.querySelectorAll('em')];
        if(this.italics == null || this.italics.length == 0) {
            this.italics = [...this.elem.querySelectorAll('.quote-header')];
            console.log(this.italics)
        }
        this.images = [...this.elem.querySelectorAll('.reveal-image')];
        // this.flashImage = this.elem.querySelector('#flash-image');
        
    }

    activateItalics() {

        // doing forEach on the italics within for loop for images?
        // console.log(this.italics.length)
        // console.log(this.images.length)
        
        for (var i = 0; i < this.italics.length && i < this.images.length; i++) {
            // check if null
            let source = this.images[i].src;
            
            // console.log(source)
            this.italics[i].setAttribute('data-image', source)
            // this.italics.forEach((item) => {
            //     // item.setAttribute('data-image', this.images[i].src)
            // })
        }
    }

    setImage(url) {
        this.flashImage.src = url;
    }
    
	showFlash(e) {

		let src = e.target.getAttribute('data-image')
        src && this.setImage(src)
        // this.flashImage.classList.add('_is-visible')
        const onMouseMove = (e) => {
            // this.flashImage.style.left = e.pageX + 'px';
            // this.flashImage.style.top = e.pageY + 'px';
        }
        this.elem.addEventListener('mousemove', onMouseMove);
    }

    init() {
        
        this.activateItalics()
        this.italics.forEach((item) => {
            item.addEventListener('mouseenter', (e) => {
                // get data attr from there, compare with data attribute of .reveal-image
                // this.showFlash(e)
                // let x = e.clientX;
                // let y = e.clientY;
                // this.flashImage.classList.add('_is-visible')
                let images = document.querySelectorAll('.reveal-image')
                const imgData = item.getAttribute
                images.forEach((image) => {
                    let italSource = image.getAttribute('src')
                    let imgSource = item.getAttribute('data-image')

                    if(italSource == imgSource) {
                        image.classList.add('is-active')
                        setTimeout(() => image.classList.remove('is-active'), 1400);
                    }
                });
            });
            // item.addEventListener('mouseleave', (e) => {
            //     setTimeout(() => image.classList.remove('is-active'), 1000);
            // });
            // item.addEventListener('mouseleave', (e) => {
            //     // this.showFlash(e)
            //     setTimeout(() => {
            //         this.flashImage.classList.remove('_is-visible')
            //     }, 1000)
            // })
                // console.log(item)
                // console.log('reveal image!')
                // console.log(item.src)
                // console.log(images)
            
        })
    }
}